import Cropper from 'cropperjs';

export default class vCrop {
  constructor(ratio) {
    this.image = {};
    this.cropper = {};
    this.ratio = ratio;
    this.jcrop = {
      JcropH: [],
      JcropW: [],
      JcropY: [],
      JcropX: [],
    };
  }

  /**
   * Init the cropper with the image event
   * @param  {event} image Image change event
   * @return {void}
   */
  init(image) {
    this.image = image;
  }

  /**
   * Load Cropperjs
   * @param  {HtmlDomElement} imageElement the <img> or <canva> element for display crop
   * @return {void}
   */
  trigger(imageElement) {
    this.cropper = new Cropper(imageElement, {
      aspectRatio: this.ratio,
      viewMode: 1,
      background: false,
      modal: false,
    });
  }

  /**
   * Return the cropped image preview
   * @return {DataUrl} Image preview
   */
  getCroppedPreview() {
    return this.cropper.getCroppedCanvas().toDataURL('image/jpeg');
  }

  /**
   * Return the cropped datas ( rounded values )
   * @return {Object} Crop values
   */
  getCroppedDatas() {
    const cropDatas = this.cropper.getData(['rounded']);

    return {
      JcropH: cropDatas.height,
      JcropW: cropDatas.width,
      JcropX: cropDatas.x,
      JcropY: cropDatas.y,
      JcropRotate: cropDatas.rotate,
    };
  }
}
